import React from 'react'
import PropTypes from 'prop-types'
import { InfoAlert } from 'components/alerts'
import { registryDiscountPath, storePath } from 'lib/urls'
import * as BLConstants from 'shared/constants'
import Link from 'components/link'
import { InfoButton } from 'components/buttons'
import { DiscountStatusIcon } from 'components/icons'

const RegItemsDiscountHeader = ({
  hasRegistryDiscountEligibleItems,
  isOwner,
  ownerName,
}) => {
  return (
    <div className="mtl mtxl-sm mbn text-center">
      {!isOwner && <NotOwnerAlert ownerName={ownerName} />}

      <DiscountStatusIcon />
      <div className="h4 text-bold">{`You've qualified for a one-time ${BLConstants.CONFIG.store.registryDiscountPctDisplay} discount at the Babylist store!`}</div>

      {hasRegistryDiscountEligibleItems ? (
        <p>
          {`Want to save on some of your registry faves or stock up before baby's arrival? Here's a list of items on your registry that are eligible for ${BLConstants.CONFIG.store.registryDiscountPctDisplay} off!`}
        </p>
      ) : (
        <p>
          {`Want to save on some of your registry faves or stock up before baby's arrival? Your single-use ${BLConstants.CONFIG.store.registryDiscountPctDisplay} discount applies to almost any item in the Babylist store!`}
        </p>
      )}
      <small className="text-muted">
        <Link className="text-underline" url={registryDiscountPath} newWindow>
          Terms and conditions
        </Link>
        {` apply. Discount will be applied in cart.`}
      </small>
      {!hasRegistryDiscountEligibleItems && (
        <div className="mtxl">
          <InfoButton href={storePath}>Shop the Babylist Store</InfoButton>
        </div>
      )}
    </div>
  )
}

RegItemsDiscountHeader.propTypes = {
  hasRegistryDiscountEligibleItems: PropTypes.bool.isRequired,
  isOwner: PropTypes.bool.isRequired,
  ownerName: PropTypes.string.isRequired,
}

const NotOwnerAlert = ({ ownerName }) => (
  <InfoAlert>
    <span className="h6 text-left">
      Heads up! Only the primary account holder {ownerName && `(${ownerName})`}{' '}
      can use the registry discount.
    </span>
  </InfoAlert>
)

NotOwnerAlert.propTypes = {
  ownerName: PropTypes.string.isRequired,
}

export default RegItemsDiscountHeader
export { NotOwnerAlert }
